import React from 'react';

const withDisableScrollRestoration = (WrappedComponent) =>
  class WithDisableScrollRestoration extends React.Component {
    componentDidMount() {
      // disables scroll restoration on back and forward navigation
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    }

    componentWillUnmount() {
      // enables scroll restoration on back and forward navigation
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

export default withDisableScrollRestoration;
